<template>
<div>
  <w-search-field class="title-bar" width="100%" @search="filterTree"/>
  <el-tree ref="tree" :data="treeData" :props="defaultProps" node-key="treeKey" default-expand-all @node-click="onClickNode"
    :expand-on-click-node="false" highlight-current :filter-node-method="filterNode">
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span>{{data.label}}</span>
    </span>
  </el-tree>
</div>
</template>

<script>
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import WSearchField from '@/components/form/SearchField';
import provisioningSettingApi from '@/api/settings/virtual/provisioning-settings';

export default {
  name: 'WVirtualCenterTree',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter],
  data() {
    return {
      treeRef: 'tree',
      selectedNode: null,
      treeData: null,
      defaultProps,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 가상화센터 트리 데이터 로드
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      provisioningSettingApi.getVirtualcenterHostTreeData({
        managerType: this.userInfo.managerType,
        managerId: this.userInfo.managerId,
      }).then((response) => {
        if (response.data.success) {
          const childrenData = response.data.data;
          this.treeData = [
            {
              label: '가상화 센터',
              treeKey: 'root',
              type: 'root',
              children: childrenData,
            },
          ];
          this.selectedNode = childrenData[0];

          this.$nextTick(() => {
            this.getTree().setCurrentKey(this.selectedNode.treeKey);
            this.onClickNode(this.getCurrentNode());
          });
        }
      });
    },
    getTree() {
      return this.$refs.tree;
    },
    getCurrentNode() {
      return this.$refs.tree.getCurrentNode() || this.selectdNode.data;
    },
    onClickNode(data, node) {
      if (data.treeKey === 'root') return;
      this.$emit('clickNode', data, node);
      this.$refs.tree.setCurrentKey(data.treeKey);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/components/VirtualCenterTree.vue